<ng-template #templateRefContent>
    <ng-content></ng-content>
</ng-template>
<ng-template #templateRefFooter>
    <ng-content select="eui-message-box-footer"></ng-content>
</ng-template>
